export default {
      id: "logo_orly-usage",
      viewBox: "0 0 240 61",
      url: "../dist/images/" + "sprite.svg#logo_orly-usage",
      toString: function () {
        return this.url;
      }
    }